<div class="web-view" style="background-color: black;">
    <div *ngIf="showSideBar">
        <app-movie-page-side-bar class="web-sideBar"></app-movie-page-side-bar>
    </div>

    <div class="background">
        <div class="content-top-bar">
            <div class="content-container">
                <!-- App top bar -->
                <ng-container>
                    <div class="sidebar-container">
                        <div (click)="openSideBar()"><i class="bi bi-list"></i></div>
                        <div (click)="backClicked()" style="cursor: pointer;">
                            <i class="bi bi-arrow-left"></i>
                        </div>
                    </div>
                    <div class="web-name">cinejoy</div>
                    <div class="container-shop-cart">
                        <!-- <app-shopping-cart></app-shopping-cart> -->
                    </div>
                </ng-container>
            </div>

            <div class="watchlist-container">
                <div>
                    <h1>My Passholder Watchlist</h1>
                </div>

                <div class="button-container">
                    <button
                        class="dynamic-button"
                        [class.active]="selectedButton === 'ALL'"
                        (click)="selectButton('ALL'); fetchEvents()"
                    >
                        All
                    </button>
                    <button
                        class="dynamic-button"
                        [class.active]="selectedButton === 'SPOTLIGHT'"
                        (click)="selectButton('SPOTLIGHT'); fetchEvents('SPOTLIGHT')"
                    >
                        Spotlight Premiere Events
                    </button>
                    <button
                        class="dynamic-button"
                        [class.active]="selectedButton === 'SHOWCASE'"
                        (click)="selectButton('SHOWCASE'); fetchEvents('SHOWCASE')"
                    >
                        Showcase Screenings
                    </button>
                    <button
                        class="dynamic-button"
                        [class.active]="selectedButton === 'SCREENING_PARTY'"
                        (click)="selectButton('SCREENING_PARTY'); fetchEvents('SCREENING_PARTY')"
                    >
                        Meetups
                    </button>
                    <button
                        class="dynamic-button"
                        [class.active]="selectedButton === 'SYMPOSIUM'"
                        (click)="selectButton('SYMPOSIUM'); fetchEvents('SYMPOSIUM')"
                    >
                        Symposiums
                    </button>
                </div>

                <div>
                    <div class="cards-container" *ngIf="events.length > 0" >
                        <div class="card" *ngFor="let event of events">
                            <p style="margin-top: 20px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                                {{ event.eventDetails.eventName }}
                            </p>
                            <div class="image-container">
                                <div class="event-type">
                                    <button class="event-button1">#{{ event.type }}</button>
                                </div>

                                <img [src]="event.eventDetails.image" class="card-image" alt="Event Image" />
                                <div class="overlay" *ngIf="event.eventDetails.description">
                                    <div *ngIf="event.eventType === 'SHOWCASE'" style="margin-bottom: 10px; display: flex; justify-content: space-between; align-items: center;">
                                        <span>Audience Rating: {{ event.eventDetails.rating }} / 10</span>
                                        <span>{{ event.eventDetails.duration }}</span>
                                    </div>                                  
                                    <div *ngIf="event.eventType === 'SPOTLIGHT'" style="margin-bottom: 10px;">
                                        {{event.eventDetails.spotlightDate | date : "EEE, MMMM d, y, h:mm:ss a"}} {{userTimezoneNameSP(event.eventDetails.spotlightDate)}}
                                    </div>
                                    <div *ngIf="event.eventType === 'SYMPOSIUM'" style="margin-bottom: 10px;">
                                        {{event.eventDetails.symposiumDate | date : "EEE, MMMM d, y, h:mm:ss a"}} {{userTimezoneNameSP(event.eventDetails.symposiumDate)}}
                                    </div>
                                    <p class="description" [innerHTML]="event.eventDetails.description" [ngClass]="{ 'expanded': event.showFullDescription }">
                                    </p>
                                    <button *ngIf="event.eventDetails.description.length > 40" class="read-more" (click)="toggleDescription(event)">
                                        {{ event.showFullDescription ? 'Read Less' : 'Go To Page' }}
                                    </button>
                                </div>
                            </div>
                        
                            <div class="card-actions">
                               <div>
                                <i class="bi bi-trash delete" (click)="deleteEvent(event)">
                                </i>
                               </div>

                               <div class="dates">
                                <div *ngIf="event.eventType === 'SPOTLIGHT'" >
                                    {{event.eventDetails.spotlightDate | date : "MMM d, y, h:mm a"}} {{userTimezoneNameSP(event.eventDetails.spotlightDate)}}
                                </div>
                                <div *ngIf="event.eventType === 'SYMPOSIUM'" >
                                    {{event.eventDetails.symposiumDate | date : "MMM d, y, h:mm a"}} {{userTimezoneNameSP(event.eventDetails.symposiumDate)}}
                                </div>
                                <div *ngIf="event.eventType === 'SHOWCASE'">
                                   Rating: {{event.eventDetails.rating}}/10
                                </div>
                                <div *ngIf="event.eventType === 'SCREENING_PARTY'">
                                    {{event.eventDetails.screeningPartyMeetingDate | date : "MMM d, y, h:mm a"}} {{userTimezoneNameSP(event.eventDetails.screeningPartyMeetingDate)}}
                                 </div>
                            </div>

                                <div class="form-check form-switch">
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        [(ngModel)]="event.isMustSee"
                                        (change)="UpdatePassholderWatchlist(event.eventId, event.isMustSee, event.eventType)"
                                    />
                                    <label class="form-check-label">Must See</label>
                                </div>

                                <!-- <div>
                                    <button class="event-button1">#{{ event.type }}</button>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="events.length === 0" class="no-content-container">
                    <div class="no-content-message">
                        <img src="../../../../../assets/images/mobilepass.png" alt="Bookmark Image"/>
                        <h2>Passholders Exclusive Watchlist</h2>
                        <h2 *ngIf="selectedButton === 'ALL'">No Content Added Yet</h2>
                        <h2 *ngIf="selectedButton === 'SPOTLIGHT'">No Spotlight Events Added Yet</h2>
                        <h2 *ngIf="selectedButton === 'SHOWCASE'">No Showcase Movies Added Yet</h2>
                        <h2 *ngIf="selectedButton === 'SCREENING_PARTY'">No Screening Parties Added Yet</h2>
                        <h2 *ngIf="selectedButton === 'SYMPOSIUM'">No Symposiums Added Yet</h2>

                        <p class="main-description">
                            <ng-container *ngIf="selectedButton === 'ALL'">
                                Welcome to the Passholders Watchlist, after you have purchased an <a style="color: #DE1B36;" href="/cinejoy/all-access-pass" target="_blank">All-Access Pass</a>,
                                you can bookmark Events and Screenings you are interested in experiencing by
                                hitting the PASS button on their pages. You can then return to My Watchlist to
                                review and organize your Cinejoy Experience! Thank you for your support of the
                                Cinequest Artists and their exciting work featured on Cinejoy.
                            </ng-container>

                            <ng-container *ngIf="selectedButton === 'SPOTLIGHT'">
                                After you have an <a style="color: #DE1B36;" href="/cinejoy/all-access-pass" target="_blank">All-Access Pass</a>, you can bookmark Events and 
                                Screenings you are interested in experiencing by hitting the PASS button on their 
                                pages.
                            </ng-container>

                            <ng-container *ngIf="selectedButton === 'SHOWCASE'">
                                After you have an <a style="color: #DE1B36;" href="/cinejoy/all-access-pass" target="_blank">All-Access Pass</a>, you can bookmark Events and 
                                Screenings you are interested in experiencing by hitting the PASS button on their 
                                pages.
                            </ng-container>

                            <ng-container *ngIf="selectedButton === 'SCREENING_PARTY'">
                                After you have an <a style="color: #DE1B36;" href="/cinejoy/all-access-pass" target="_blank">All-Access Pass</a>, you can bookmark Events and 
                                Screenings you are interested in experiencing by hitting the PASS button on their 
                                pages.
                            </ng-container>

                            <ng-container *ngIf="selectedButton === 'SYMPOSIUM'">
                                After you have an <a style="color: #DE1B36;" href="/cinejoy/all-access-pass" target="_blank">All-Access Pass</a>, you can bookmark Events and 
                                Screenings you are interested in experiencing by hitting the PASS button on their 
                                pages.
                            </ng-container>
                        </p>

                        <div class="button-group">
                            <button *ngIf="selectedButton === 'ALL'" class="action-button" (click)="navigateTo('SPOTLIGHT')">Add Spotlights</button>
                            <button *ngIf="selectedButton === 'ALL'" class="action-button" (click)="navigateTo('SHOWCASE')">Add Showcases</button>
                            <button *ngIf="selectedButton === 'ALL'" class="action-button" (click)="navigateTo('SCREENING_PARTY')">Add Meetups</button>
                            <button *ngIf="selectedButton === 'ALL'" class="action-button" (click)="navigateTo('SYMPOSIUM')">Add Symposiums</button>
                            
                            <button *ngIf="selectedButton === 'SPOTLIGHT'" class="action-button" (click)="navigateTo('SPOTLIGHT')">Add Spotlights</button>
                            <button *ngIf="selectedButton === 'SHOWCASE'" class="action-button" (click)="navigateTo('SHOWCASE')">Add Showcases</button>
                            <button *ngIf="selectedButton === 'SCREENING_PARTY'" class="action-button" (click)="navigateTo('SCREENING_PARTY')">Add Meetups</button>
                            <button *ngIf="selectedButton === 'SYMPOSIUM'" class="action-button" (click)="navigateTo('SYMPOSIUM')">Add Symposiums</button>
                        </div>
                    </div>
                </div>
                               
            </div>
        </div>
    </div>
</div>
